import React from "react";
import { Box } from "@material-ui/core";
import { EmailOutlined, PhoneOutlined } from "@material-ui/icons";
import ContactUsForm from "./ContactUsForm";

const App = () => {
  return (
    <Box className="mainRootClass">
      <Box className="rootContainerContactUs">
        <Box className="cardContainer">
          <Box id="contactBox" className="containWraper">
            <Box id="contactInfo" className="contactDescription">
              <Box className="columnText">
                Contact
                <span style={{ color: "#E00000" }}> Details</span>
              </Box>
              <Box className="containWraper">
               <Box className="infoRow">
                  <Box className="contactAddressSection">
                    <Box className="fontStyleText">
                      National and Sponsorship Enquiries
                    </Box>
                    <Box className="fontStyleText"> Captain Ben</Box>
                    <Box className="fontStyleText">
                      <span style={{ marginTop: 5 }}>
                        <EmailOutlined fontSize="small" color="error" />{" "}
                      </span>
                      <span
                        style={{ marginLeft: 8}}
                      >
                        <a href="mailto:info@motorevents.com.au">info@motorevents.com.au</a>
                      </span>
                    </Box>
                    <Box className="fontStyleText">
                      <span style={{ marginTop: 5 }}>
                        <PhoneOutlined fontSize="small" color="error" />{" "}
                      </span>
                      <span style={{ marginLeft: 8 }}>0432 364 433</span>
                    </Box>
                  </Box>
                  <Box className="contactAddressSection">
                    <Box className="fontStyleText">
                      NSW/ACT Event Enquiries
                    </Box>
                    <Box className="fontStyleText">Captain Ben</Box>
                    <Box className="fontStyleText">
                      <span style={{ marginTop: 5 }}>
                        <EmailOutlined fontSize="small" color="error" />
                      </span>
                      <span
                        style={{ marginLeft: 8 }}
                      >
                        <a href="mailto:NSW@motorevents.com.au">NSW@motorevents.com.au</a>
                      </span>
                    </Box>
                    <Box className="fontStyleText">
                      <span style={{ marginTop: 5 }}>
                        <PhoneOutlined fontSize="small" color="error" />{" "}
                      </span>
                      <span style={{ marginLeft: 8 }}>0432 364 433</span>
                    </Box>
                </Box>
              </Box> 
                <Box className="infoRow">

                                    <Box
                    display="flex"
                    flexDirection="column"
                    className="contactAddressSection"
                  >
                    <Box className="fontStyleText">
                      SA/TAS/WA Event Enquiries
                    </Box>
                    <Box className="fontStyleText">
                      David "Nürburgring" Nelson
                    </Box>
                    <Box className="fontStyleText">
                      <span style={{ marginTop: 5 }}>
                        <EmailOutlined fontSize="small" color="error" />{" "}
                      </span>
                      <span
                        style={{ marginLeft: 8}}
                      >
                        <a href="mailto:SA@motorevents.com.au">SA@motorevents.com.au</a>
                        
                      </span>
                    </Box>
                    <Box className="fontStyleText">
                      <span style={{ marginTop: 5 }}>
                        <PhoneOutlined fontSize="small" color="error" />{" "}
                      </span>
                      <span style={{ marginLeft: 8 }}>0432 829 899</span>
                    </Box>
                  </Box>
                
                  <Box
                    display="flex"
                    flexDirection="column"
                    className="contactAddressSection"
                  >
                    <Box className="fontStyleText">
                      VIC Event Enquiries
                    </Box>
                    <Box className="fontStyleText">
                    Lethal Leigh & Rockstar Harrison
                    </Box>
                    <Box className="fontStyleText">
                      <span style={{ marginTop: 5 }}>
                        <EmailOutlined fontSize="small" color="error" />{" "}
                      </span>
                      <span
                        style={{ marginLeft: 8}}
                      >
                        <a href="mailto:VIC@motorevents.com.au">VIC@motorevents.com.au</a>
                        
                      </span>
                    </Box>
                    <Box className="fontStyleText">
                      <span style={{ marginTop: 5 }}>
                        <PhoneOutlined fontSize="small" color="error" />{" "}
                      </span>
                      <span style={{ marginLeft: 8 }}>0408 504 087</span>
                    </Box>
                  </Box>
                </Box>
                <Box className="infoRow">
                   <Box className="contactAddressSection">
                      <Box className="fontStyleText">
                        QLD/NT Event Enquiries
                    </Box>
                    <Box className="fontStyleText"> Captain Ben</Box>
                      <Box className="fontStyleText">
                        <span style={{ marginTop: 5 }}>
                          <EmailOutlined fontSize="small" color="error" />{" "}
                        </span>
                        <span
                          style={{ marginLeft: 5}}
                        >
                          <a href="mailto:QLD@motorevents.com.au">QLD@motorevents.com.au</a>
                        </span>
                      </Box>
                      <Box className="fontStyleText">
                        <span style={{ marginTop: 5 }}>
                          <PhoneOutlined fontSize="small" color="error" />{" "}
                        </span>
                        <span style={{ marginLeft: 8 }}>0432 364 433</span>
                      </Box>
                    </Box>
                
                </Box>
              </Box>
            </Box>
            <Box id="contactWebForm" className="contactWidth">
              <Box
                width="100%"
                style={{
                  backgroundImage: `url(https://i.ibb.co/Jm5xPD5/osman-rana-G7-VN8-Nadj-O0-unsplash-1.png)`,
                  backgroundSize: "cover",
                  backgroundPosition: "center center",
                  backgroundRepeat: "no-repeat",
                  height: "100%",
                }}
              >
                <ContactUsForm />
              </Box>
            </Box>
          </Box>
        </Box>
      </Box>
    </Box>
  );
};

export default App;
